export enum UploadStatus {
  QUEUED = 'queued',
  UPLOADING = 'uploading',
  UPLOADED = 'uploaded',
  RETRYING = 'retrying',
  FAILED = 'failed',
}

export interface UploadRecord {
  fileId: string;
  fileName: string;
  fileSize: number;
  status: UploadStatus;
  presignedUrl: string | null;
  s3Key: string | null;
  retryCount: number;
  maxRetries: number;
  nextRetryAt: number | null;
  errorMessage: string | null;
  createdAt: number;
  updatedAt: number;
  /** Set for add-patient uploads; used when calling confirm. */
  userId?: string;
  activity?: string;
  facility?: string;
  recordDate?: string;
}
